import React, { useState } from "react";
import { contactFormPost } from "../Api";

const initState = {
  name: "",
  email: "",
  phone: "",
  subject: "",
  message: "",
};

const ContactFormModal = ({ open, handleClose }) => {
  const [formData, setFormData] = useState(initState);
  const [successMessage,setSuccessMessage] = useState('')

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await contactFormPost(formData);
      setFormData(initState);
      setSuccessMessage(res.message)
    } catch (err) {
      setSuccessMessage('Something went wrong')
      console.error("Form error:", err);
    }
  };

  return (
    <div
      className={`modal ${open ? "show" : ""}`}
      style={{ paddingTop: "20px" }}
    >
      <div className="col-lg-6" style={{ paddingInline: "20px" }}>
        <div
          className="ttm-bgcolor-skincolor spacing-7"
          style={{ position: "relative", marginInline: "10px" }}
        >
          {/* Close Button */}
          <button
            onClick={() => {
              handleClose();
              setFormData(initState);
            }}
            style={{
              position: "absolute",
              top: "10px",
              right: "-10px",
              fontSize: "20px",
              border: "none",
              background: "transparent",
              cursor: "pointer",
            }}
          >
            &times;
          </button>

          {/* Section Title */}
          <div className="section-title text-left with-desc clearfix">
            <div className="title-header">
              <h2 className="title">Let’s Start Conversation.</h2>
            </div>
          </div>

          {/* Form */}
          <form
            id="ttm-contactform"
            className="ttm-contactform wrap-form clearfix"
            onSubmit={handleSubmit}
          >
            {/* <input type="hidden" name="form-name" value="contact" /> */}

            <div className="row">
              <div className="col-md-6">
                <label>
                  <span className="text-input">
                    <input
                      name="name"
                      value={formData.name}
                      type="text"
                      placeholder="Your Name"
                      required
                      onChange={handleChange}
                    />
                  </span>
                </label>
              </div>
              <div className="col-md-6">
                <label>
                  <span className="text-input">
                    <input
                      name="email"
                      type="email"
                      value={formData.email}
                      placeholder="Your Email"
                      required
                      onChange={handleChange}
                    />
                  </span>
                </label>
              </div>
            </div>

            <div className="row">
              <div className="col-md-6">
                <label>
                  <span className="text-input">
                    <input
                      name="phone"
                      type="text"
                      value={formData.phone}
                      placeholder="Your Phone"
                      required
                      onChange={handleChange}
                    />
                  </span>
                </label>
              </div>
              <div className="col-md-6">
                <label>
                  <span className="text-input">
                    <input
                      name="subject"
                      type="text"
                      value={formData.subject}
                      placeholder="Subject"
                      required
                      onChange={handleChange}
                    />
                  </span>
                </label>
              </div>
            </div>

            <label>
              <span className="text-input">
                <textarea
                  name="message"
                  value={formData.message}
                  cols={40}
                  rows={3}
                  placeholder="Message"
                  required
                  onChange={handleChange}
                />
              </span>
            </label>
            {successMessage && <p>{successMessage}</p>}
            <button
              className="submit ttm-btn ttm-btn-size-md ttm-btn-shape-square ttm-btn-bgcolor-darkgrey"
              type="submit"
            >
              Send
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ContactFormModal;
